var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"mb-4"},[_c('input',{ref:_vm.name,staticClass:"mr-2",attrs:{"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.changeValue}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }